import { render, staticRenderFns } from "./VentilatorSwitch.vue?vue&type=template&id=cdd5c8e8&scoped=true&"
import script from "./VentilatorSwitch.vue?vue&type=script&lang=ts&"
export * from "./VentilatorSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./VentilatorSwitch.vue?vue&type=style&index=0&id=cdd5c8e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd5c8e8",
  null
  
)

export default component.exports